import defaultCode from "./defaultCode";
import lesson from "./lesson";
import test from "./test";

export default {
    name: "Insertion",
    defaultCode,
    lesson,
    test,
    difficulty: 1,
};
